import { Injectable } from "@angular/core";
import Swal, { SweetAlertResult } from "sweetalert2";

@Injectable({ providedIn: "root" })
export class FacturadorNotificationService {
	error(titulo: string, mensaje: string): Promise<SweetAlertResult> {
		return Swal.fire({ icon: "error", title: titulo, text: mensaje });
	}

	exito(titulo: string, mensaje: string): Promise<SweetAlertResult> {
		return Swal.fire({ icon: "success", title: titulo, text: mensaje });
	}

	advertencia(titulo: string, mensaje: string): Promise<SweetAlertResult> {
		return Swal.fire({ icon: "warning", title: titulo, text: mensaje });
	}
}
